import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import FilterSelect from "../../../components/select/filterSelect";
import InputTextField from "../../../components/input/inputTextField";
import InputDatePicker from "../../../components/input/inputDatePicker";
import { StudentRegistrationAdminApi } from "../../../api/student-registration-admin/student-registration-admin.api";
import { handleTypingNumber } from "../../../utils/app.utils";
import { alertError, alertSuccess, swalError } from "../../../components/alert/swal";
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { AcademicYearApi } from "../../../api/academic-year/academic-year.api";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();

    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("");


    const [data, setData] = useState<any[]>([]);
    const [form, setForm] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [degree, setDegree] = useState<any[]>([]);
    const [faculty, setFaculty] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>("ALL");
    const [id_faculty, set_id_faculty] = useState<any>("ALL");
       
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 300, sortable: false, disablePadding: false, align: 'left', label: t("STUDENT_REGISTRATION_NAME_SURNAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 200, align: "left", label: t("STUDENT_REGISTRATION_NICKNAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("STUDENT_REGISTRATION_LEVEL")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 241, label: t("STUDENT_REGISTRATION_COURSE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("STUDENT_REGISTRATION_ADMISSION_YEAR")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("STUDENT_REGISTRATION_ADMISSION_START_DATE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("STUDENT_REGISTRATION_YEAR_LEVEL")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 200, label: t("STUDENT_REGISTRATION_CLASSROOM")
        },
        // {
        //     id: "status", disablePadding: false, align: "center", width: 250, label: t("รหัสประจำตัวนักศึกษา")
        // },
        // {
        //     id: "status", disablePadding: false, align: "center", width: 250, label: t("อีเมลนักศึกษา")
        // },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            full_name,
            middle_name,
            degree_name,
            faculty_name,
            term,
            academic_year,
            date_first_studies,
            room,
            id_admission_student,
            admission_status,
            room_one
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: full_name || "-" },

                {
                    option: "TEXT",
                    align: "left",
                    label: middle_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <>
                        <FilterSelect
                            style={{ padding: 0 }}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }}
                            value={academic_year || ''}
                            labelId={"1"}
                            disabled
                            selectId={"1"}
                            options={[academic_year].map((x) => {
                                return (
                                    <MenuItem value={x} key={x}>
                                        {x}
                                    </MenuItem>
                                )
                            })}
                        />
                    </>,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <InputDatePicker value={date_first_studies || ''} disabled onChange={function (val: any): void {
                        throw new Error("Function not implemented.");
                    }} />,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <>
                        <FilterSelect
                            style={{ padding: 0 }}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }}
                            value={term || ''}
                            labelId={"1"}
                            selectId={"1"}
                            disabled
                            options={[term].map((x) => {
                                return (
                                    <MenuItem value={x} key={x}>
                                        {x}
                                    </MenuItem>
                                )
                            })}
                        />
                    </>,
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: <>
                        <FilterSelect
                            style={{ padding: 0 }}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setForm((prevData) =>
                                    prevData.map((q) =>
                                        id_admission_student === q?.id_admission_student
                                            ? {
                                                ...q,
                                                room: e.target.value
                                            }
                                            : q
                                    )
                                );
                            }}
                            value={room_one || form?.find((item: any) => item?.id_admission_student === id_admission_student)?.room || ''}
                            labelId={"1"}
                            selectId={"1"}
                            options={room.split(',')?.map((x: any) => {
                                return (
                                    <MenuItem value={x} key={x}>
                                        {x}
                                    </MenuItem>
                                )
                            })}
                            disabled={admission_status === 'ACCEPTED_STUDENT'}
                        />
                    </>,
                },
                // {
                //     option: "COMPONENT",
                //     align: "center",
                //     component: <>
                //         <InputTextField placeholder="ระบุ" onchange={(e) => {
                //             setForm((prevData) =>
                //                 prevData.map((q) =>
                //                     id_admission_student === q?.id_admission_student
                //                         ? {
                //                             ...q,
                //                             student_no: e.target.value
                //                         }
                //                         : q
                //                 )
                //             );
                //         }} onkeypress={handleTypingNumber} />
                //     </>,
                // },
                // {
                //     option: "COMPONENT",
                //     align: "center",
                //     component: <>
                //         <InputTextField placeholder="ระบุ" onchange={(e) => {
                //             setForm((prevData) =>
                //                 prevData.map((q) =>
                //                     id_admission_student === q?.id_admission_student
                //                         ? {
                //                             ...q,
                //                             email: e.target.value
                //                         }
                //                         : q
                //                 )
                //             );
                //         }} />
                //     </>,
                // },

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <IconButton onClick={() => navigate(routeName.admission.student_registration_view.replace(':id', `${id_admission_student}`))}>
                            <ArrowForwardIosIcon />
                        </IconButton>
                        {/* <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => handleGetOneDetail(id_comment, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_comment)}
                        /> */}
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, keyword: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
      
        dispatch(setLoading());
        await StudentRegistrationAdminApi.getList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setForm(res.data?.data?.items?.filter((x:any) => x?.admission_status !== 'ACCEPTED_STUDENT').map((item: any) => {
                    return {
                        id_admission_student: item?.id_admission_student,
                        id_student: item?.id_student
                    }
                }) || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, id_degree, id_faculty,])


    useEffect(() => {
        handleGetData()
    }, [handleGetData])
    const getDegree = async () => {
        await degreeApi.getDegree().then((res) => {
            if (res.status < 300) {
                setDegree(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getFaculty = async () => {
        await facultyApi.getFaculty().then((res) => {
            if (res.status < 300) {
                setFaculty(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
   

    useEffect(() => {
        getDegree()
        getFaculty()
    }, [])

    // console.log(form);
    const handleSubmit = async () => {
        const body = form.filter((x) => x.id_student && x?.room)
        await StudentRegistrationAdminApi.post(body)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("STUDENT_REGISTRATION"), t("STUDENT_REGISTRATION_SUCCESS"));
                    handleGetData()
                    // navigate(routeName.admission.AdmissionFormUpdte?.replace(':id', res.data.data?.id_admission_student))
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("STUDENT_REGISTRATION"), err?.response?.data?.message || t('เกิดข้อผิดพลาด'))
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        handleSubmit,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
     
    }
}

export default ManageState